import { Instant, LocalDate, LocalDateTime } from "@js-joda/core";
import { dateFormatter } from "../../../../../shared/utils/date-formatter";
import type { CaregiverStatusHistoryRow } from "./CaregiverProfileStatusReviewSection.types";

export function formatStatusReviewDate(value: Instant | LocalDate | LocalDateTime | string | null) {
  if (value === null || value === "") {
    return "";
  }

  if (value instanceof LocalDate) {
    return dateFormatter.toDate(value);
  }

  if (value instanceof LocalDateTime || value instanceof Instant) {
    return dateFormatter.toDateTime(value);
  }

  return value;
}

export function formatStatusReviewShortDate(
  value: Instant | LocalDate | LocalDateTime | string | null
) {
  if (value === null || value === "") {
    return "";
  }

  if (value instanceof LocalDate || value instanceof LocalDateTime || value instanceof Instant) {
    return dateFormatter.toDate(value);
  }

  return value;
}

export function formatStatusReviewUser(row: CaregiverStatusHistoryRow) {
  const userDetails = row.createdBy.userDetails;

  return [userDetails.firstName, userDetails.lastName].filter(Boolean).join(" ");
}

export function stripStatusReviewHtml(value: string) {
  return value.replace(/<[^>]*>/g, "");
}

export function formatStatusReviewNote(row: CaregiverStatusHistoryRow) {
  const reason = row.note.reason === null ? "" : stripStatusReviewHtml(row.note.reason);
  const message = row.note.message === null ? "" : stripStatusReviewHtml(row.note.message);

  if (reason !== "" && message !== "") {
    return `(${reason}) ${message}`;
  }

  if (reason !== "") {
    return `(${reason})`;
  }

  return message;
}
